import {ValueDefinition} from '@/model/types';

export enum ContractTypes {
  CI = 'DV-93#0',
  FPG = 'DV-93#1',
}

export const DV_93 = {
  id: 'DV-93',
  description: {
    fr: 'Type de contrat',
    en: 'Contract type',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Compte d’investissement Beneva',
        en: 'Beneva Investment Account',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Fonds de placement garanti',
        en: 'Guaranteed Investment Funds',
      },
    },
  ],
} as const satisfies ValueDefinition;
